const ADMIN = 'clinic_admin'
const FOUNDER = 'root'
const REGISTRY = 'registrar'
const DOCTOR = 'doctor'
const DOCTOR_ADMIN = 'doctor_admin'
const SERVICE_STAFF = 'service_staff'
const DEVICE = 'device'
const CLIENT = 'client'

//TODO remove to Vuex service for getting actual data

export default class Role {
	constructor(user, worker, clinic) {
		this.user = user || {}
		this.clinic = clinic || {}
		this.role = (worker._id) ? worker.role : user.role
		this.permissions = worker.role.permissions || {}
	}

	get isFounder() {
		return this.user._id === this.clinic.user_id || this.role.type === FOUNDER
	}

	get isAdmin() {
		return this.role.type === ADMIN || this.isFounder || this.isDoctorAdmin
	}

	get isRegistry() {
		return this.role.type === REGISTRY
	}

	get isDoctor() {
		return this.role.type === DOCTOR
	}

	get isDoctorAdmin() {
		return this.role.type === DOCTOR_ADMIN
	}

	get isServiceStaff() {
		return this.role.type === SERVICE_STAFF
	}

	get isDevice() {
		return this.role.type === DEVICE
	}

	get isClient() {
		return this.role.type === CLIENT
	}
}



// WEBPACK FOOTER //
// ./src/common/Role.js